import React from 'react';
import studentStyles from '../styles.module.css';

function StudentProgress() {
    return (
        <div className={studentStyles.mainSection}>
            Under Development
        </div>
    )
}

export default StudentProgress;
